// FETCH ALL PROPERTIES FROM COMPACTING_INWARD DETAILS
export const FETCH_COMPACTING_INWARD_DETAILS_REQUEST_DK = 'FETCH_COMPACTING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_COMPACTING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_COMPACTING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_COMPACTING_INWARD_DETAILS_FAILURE_DK = 'FETCH_COMPACTING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM COMPACTING_INWARD DETAILS BY ID
export const FETCH_COMPACTING_INWARD_DETAILS_BY_ID_REQUEST_DK = 'FETCH_COMPACTING_INWARD_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_COMPACTING_INWARD_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_COMPACTING_INWARD_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_COMPACTING_INWARD_DETAILS_BY_ID_FAILURE_DK = 'FETCH_COMPACTING_INWARD_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR COMPACTING_INWARD DETAILS
export const CREATE_COMPACTING_INWARD_DETAILS_REQUEST_DK = 'CREATE_COMPACTING_INWARD_DETAILS_REQUEST_DK';
export const CREATE_COMPACTING_INWARD_DETAILS_SUCCESS_DK = 'CREATE_COMPACTING_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_COMPACTING_INWARD_DETAILS_FAILURE_DK = 'CREATE_COMPACTING_INWARD_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_COMPACTING_INWARD_DETAILS_DK = 'CREATE_USER_FORM_COMPACTING_INWARD_DETAILS_DK';

// UPDATE PROPERTIES FOR COMPACTING_INWARD DETAILS
export const UPDATE_COMPACTING_INWARD_DETAILS_REQUEST_DK = 'UPDATE_COMPACTING_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_COMPACTING_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_COMPACTING_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_COMPACTING_INWARD_DETAILS_FAILURE_DK = 'UPDATE_COMPACTING_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE COMPACTING_INWARD_DETAILS
export const FETCH_SINGLE_COMPACTING_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_COMPACTING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_COMPACTING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_COMPACTING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_COMPACTING_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_COMPACTING_INWARD_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR COMPACTING_INWARD DETAILS
export const DELETE_COMPACTING_INWARD_DETAILS_REQUEST_DK = 'DELETE_COMPACTING_INWARD_DETAILS_REQUEST_DK';
export const DELETE_COMPACTING_INWARD_DETAILS_SUCCESS_DK = 'DELETE_COMPACTING_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_COMPACTING_INWARD_DETAILS_FAILURE_DK = 'DELETE_COMPACTING_INWARD_DETAILS_FAILURE_DK';

export const FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_REQUEST_DK = 'FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_FAILURE_DK = 'FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_FAILURE_DK';

// USERFORM RESET

export const COMPACTING_INWARD_DETAILS_USERFORM_RESET_DK = 'COMPACTING_INWARD_DETAILS_USERFORM_RESET_DK';

export const COMPACTING_INWARD_DETAILS_DC_DETAILS_DISABLED_DK = 'COMPACTING_INWARD_DETAILS_DC_DETAILS_DISABLED_DK';
